export const protectPhoneInState = (state: any): state is { phone: string } =>
  !!(state && 'phone' in (state as { phone: string }));
